export default __webpack_public_path__ + "static/media/kitchen3-afterI-1024w.d70eb6bc.avif";